import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines } from "@/components/ui/motion";
import { SITE } from "@/lib/config";

export const AboutTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section ref={ref} className="py-20 sm:py-28 lg:py-36" data-testid="about-teaser">
      <div className="wrap grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[1.5rem] rounded-tl-[9rem]">
            <motion.img style={{ y, scale: 1.2 }} src="/images/meeting.jpg" alt="Konsultan menjelaskan dokumen kepada klien" loading="lazy" className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 right-4 rounded-2xl bg-sky-brand px-6 py-4 font-display text-[15px] font-bold text-ink shadow-[0_20px_40px_-20px_rgba(2,132,199,.6)] sm:right-[-24px]">
            Bagian dari {SITE.parent.name}
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <span className="eyebrow">Tentang Kami</span>
          <MaskLines as="h2" inView className="mt-5 font-display text-3xl font-bold leading-[1.05] sm:text-5xl lg:text-[60px]" lines={["Solusi yang", <>Berawal dari <span className="serif-it font-normal text-accentb">Pemahaman.</span></>]} />
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-ink md:text-lg">
              MIKA SOLUTION merupakan bagian dari {SITE.parent.name}. Kami hadir untuk membantu masyarakat memahami kondisi kewajiban finansial, mengevaluasi pilihan penyelesaian yang tersedia, serta menjalani proses pendampingan secara lebih terarah dan transparan.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/tentang-kami" className="btn btn-slate" data-testid="about-teaser-cta">Kenali Kami <ArrowUpRight size={16} /></Link>
              <a href={SITE.parent.url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" data-testid="about-parent-link">Situs {SITE.parent.name}</a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
